import { LoadingOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Input, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import CreatePerfCycleApi from "../../../api/CreatePerfCycleApi";
import { GetPlanTemplatesApi } from "../../../api/plan-templates/GetPlanTemplatesApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";

const { RangePicker } = DatePicker;
const { Option } = Select;

function AddPerfCycleModal(props) {
  const [submit, setSubmit] = useState(false);
  const [templates, setTemplates] = useState();

  useEffect(() => {
    if (props.visible) {
      getTemplates();
    }
  }, [props.visible]);

  function handleCancel() {
    setSubmit(false);
    setTemplates();
    props.handleCancel();
  }

  async function onFinish(values) {
    setSubmit(true);
    const apiResponse = await CreatePerfCycleApi(
      values.name,
      values.templateId,
      values.date[0],
      values.date[1]
    );

    if (apiResponse.statusCode) {
      openNotificationError(
        "bottomRight",
        "Couldn't add cycle. Try again later."
      );
    } else if (apiResponse.message === "success") {
      openNotificationSuccess("bottomRight", "Perf cycle added successfully");

      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add cycle. Try again later."
      );
    }
    handleCancel();
  }

  async function getTemplates() {
    const apiResponse = await GetPlanTemplatesApi();
    if (apiResponse.success) {
      setTemplates(apiResponse.data);
    }
  }

  return (
    <Modal
      title="Add performance cycle"
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={props.handleCancel}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="addPerfCycle"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          label="Cycle name*"
          name="name"
          rules={[
            {
              required: true,
              message: "Please give a name!",
            },
          ]}
        >
          <Input placeholder="Cycle name" />
        </Form.Item>

        <Form.Item
          label="Period*"
          name="date"
          rules={[
            {
              required: true,
              message: "Please enter starting and ending date!",
            },
          ]}
        >
          <RangePicker className="w-full" />
        </Form.Item>

        <Form.Item
          label="Plan template"
          name="templateId"
          rules={[
            {
              required: true,
              message: "Please select a template!",
            },
          ]}
        >
          <Select
            allowClear
            showSearch
            placeholder="Select template"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {templates?.map((temp) => {
              return (
                <Option key={temp.id} value={temp.id}>
                  {temp.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Add"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddPerfCycleModal;
